import { takeLatest, put, take, race, select, delay } from 'redux-saga/effects';
import types from 'redux/types';
import hooks from 'hooks';
import DomainServices from 'services/DomainServices';
import { isResponseSuccess, getValueFromFormik, checkIsLast } from 'helpers';
import { TIME_OUT_CLOSE_TOAST } from 'consts/data';
import { showError } from 'helpers/handleError';

import isArray from 'lodash/isArray';
import { notifySuccess } from '../../helpers/handleNotification';
import { isEmpty } from 'lodash';
import { handleWorker } from 'helpers/saga';
import components, { typeUnmounted } from 'consts/components';

const { Notification } = hooks;

function* getDomain() {
  try {
    const response = yield DomainServices.getDomain();
    if (isResponseSuccess(response.status)) {
      yield put({
        type: types.REQUEST_GET_DOMAIN_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_GET_DOMAIN_FAILED, error });
  }
}

let TimerAddDomain;
function* addDomain(data) {
  const { domains, toggle, idDomainGroup, filters } = data;
  try {
    clearTimeout(TimerAddDomain);
    const response = yield DomainServices.addDomain({
      domains,
      groupId: idDomainGroup,
    });
    if (isResponseSuccess(response.status)) {
      yield put({ type: types.REQUEST_ADD_DOMAIN_SUCCESS });
      response.data.result.forEach((domain, index) => {
        TimerAddDomain = setTimeout(() => {
          if (domain.success) {
            Notification(
              'success',
              `Domain: ${domain.domain} is added successfully!`,
              'Success',
              TIME_OUT_CLOSE_TOAST
            );
          } else {
            showError(`Domain: ${domain.domain} - ${domain.message}`);
          }
        }, 500 * index);
      });
      toggle();
      yield loadDomainsInGroup({ idDomainGroup, filters });
    }
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_ADD_DOMAIN_FAILED, error });
  }
}

function* deleteDomain(data) {
  const { domains, callbacks } = data;
  try {
    const response = yield DomainServices.deleteDomain({ domains });
    if (isResponseSuccess(response.status)) {
      yield put({ type: types.REQUEST_DELETE_DOMAIN_SUCCESS });
      Notification('success', 'Delete Domains Successfully', '', TIME_OUT_CLOSE_TOAST);
      callbacks && callbacks.onSuccess();
    }
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_DELETE_DOMAIN_FAILED, error });
    callbacks && callbacks.onFailed();
  }
}

function* searchDomain(data) {
  const tld = getValueFromFormik(data.tld);
  const domain = getValueFromFormik(data.domain);
  const price_from = Number(getValueFromFormik(data.price_from));
  const price_to = Number(getValueFromFormik(data.price_to));
  const quantity = Number(getValueFromFormik(data.quantity));
  const unicodeIncluded = getValueFromFormik(data?.unicodeIncluded);

  try {
    const { response, cancelled } = yield race({
      response: DomainServices.searchDomain({
        tld,
        domain,
        price_from,
        price_to,
        quantity,
        unicodeIncluded,
      }),
      cancelled: take([types.REQUEST_SEARCH_DOMAIN_CANCEL, types.REQUEST_CLEAR_DATA_SEARCH_DOMAIN]),
    });

    if (cancelled) {
      yield put({ type: types.REQUEST_SEARCH_DOMAIN_CANCELLED });
      return;
    }

    if (isResponseSuccess(response.status)) {
      yield put({
        type: types.REQUEST_SEARCH_DOMAIN_SUCCESS,
        data: response.data,
      });
    }
  } catch (error) {
    showError(error);
    yield put({
      type: types.REQUEST_SEARCH_DOMAIN_FAILED,
      error: error.response,
    });
  }
}

function* buyDomain(data) {
  const { domains, toggle, idDomainGroup, callbacks } = data;
  try {
    const response = yield DomainServices.buyDomain({
      domains,
      groupId: idDomainGroup,
    });
    if (isResponseSuccess(response.status)) {
      const {
        data: { result = [] },
      } = response;
      (result || []).forEach((eachResult, idx) => {
        if (eachResult?.success) {
          setTimeout(() => {
            notifySuccess(`Buy domain: ${eachResult?.domain || ''} successfully!`);
          }, idx * 500);
        } else {
          setTimeout(() => {
            showError(`Buy domain: ${eachResult?.domain || ''} failed!`);
          }, idx * 500);
        }
      });

      yield put({
        type: types.REQUEST_BUY_DOMAIN_SUCCESS,
        data: response.data,
      });
      callbacks && callbacks.onSuccess();
      toggle();
    }
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_BUY_DOMAIN_FAILED, error: error.response });
  }
}

let TimerUpdateAllDomain;
function* updateAllDomain() {
  try {
    clearTimeout(TimerUpdateAllDomain);
    const response = yield DomainServices.updateAllDomain();
    if (isResponseSuccess(response.status)) {
      response.data.result.forEach((el, index) => {
        TimerUpdateAllDomain = setTimeout(() => {
          if (el.success) {
            Notification(
              'success',
              `Verify domain: ${el.domain} successfully! `,
              'Success',
              TIME_OUT_CLOSE_TOAST
            );
          } else {
            showError(`Verify domain: ${el.domain} failed! \n Message: ${el.message}`);
          }
        }, 500 * index);
      });
      Notification(
        'success',
        'Request verify all domain, the checking process is running',
        'Success',
        TIME_OUT_CLOSE_TOAST
      );
      yield put({ type: types.REQUEST_UPDATE_ALL_DOMAIN_SUCCESS });
    }
  } catch (error) {
    showError(error);
    yield put({
      type: types.REQUEST_UPDATE_ALL_DOMAIN_FAILED,
      error: error.response,
    });
  }
}

let TimerUpdateDomain;
function* updateDomain(data) {
  const { domains } = data;
  try {
    clearTimeout(TimerUpdateDomain);
    const response = yield DomainServices.updateDomain({ domains });
    if (isResponseSuccess(response.status)) {
      response.data.result.forEach((el, index) => {
        TimerUpdateDomain = setTimeout(() => {
          if (el.success) {
            Notification(
              'success',
              `Verify domain: ${el.domain} successfully! `,
              'Success',
              TIME_OUT_CLOSE_TOAST
            );
          } else {
            showError(`Verify domain: ${el.domain} failed! \n Message: ${el.message} `);
          }
        }, 500 * index);
      });
    }
    yield put({ type: types.REQUEST_UPDATE_DOMAIN_SUCCESS });
  } catch (error) {
    showError(error);
    yield put({
      type: types.REQUEST_UPDATE_DOMAIN_FAILED,
      error: error.response,
    });
  }
}

let TimerSetupDomain;
function* setupDomain(data) {
  const { domains } = data;
  try {
    clearTimeout(TimerSetupDomain);
    const response = yield DomainServices.setupDomain({ domains });
    if (isResponseSuccess(response.status)) {
      response.data.result.forEach((el, index) => {
        TimerSetupDomain = setTimeout(() => {
          if (el.success) {
            Notification(
              'success',
              `Setup domain: ${el.domain} successfully! `,
              'Success',
              TIME_OUT_CLOSE_TOAST
            );
          } else {
            const message = JSON.parse(el.message);
            showError(
              `Setup domain: ${el.domain} failed \n Message: ${message.errors[0].message} `
            );
          }
        }, 500 * index);
      });
      yield put({ type: types.REQUEST_SETUP_DOMAIN_SUCCESS });
    }
  } catch (error) {
    showError(error);
    yield put({
      type: types.REQUEST_SETUP_DOMAIN_FAILED,
      error: error.response,
    });
  }
}

function* getAllDomainGroup(data) {
  const { filters = {}, callbacks } = data;
  try {
    const res = yield DomainServices.getAllDomainGroup(filters);
    if (isResponseSuccess(res.data.code)) {
      callbacks && callbacks.onSuccess(res);
      yield put({
        type: types.REQUEST_GET_ALL_DOMAIN_GROUP_SUCCESS,
        data: res?.data?.domainGroups || [],
        total: res?.data?.total || 0,
        isLast: checkIsLast(res.data.domainGroups, filters.limit),
      });
    }
  } catch (error) {
    callbacks && callbacks.onFailed(error);
    showError(error);
    yield put({ type: types.REQUEST_GET_ALL_DOMAIN_GROUP_FAILED, error });
  }
}

function* loadMoreAllDomain(data) {
  const { filters = {} } = data;
  const { limit, offset, name } = filters;
  try {
    const res = yield DomainServices.getAllDomainGroup({ limit, offset, name });
    if (isResponseSuccess(res.data.code)) {
      yield put({
        type: types.REQUEST_LOAD_MORE_ALL_DOMAIN_SUCCESS,
        data: res.data.domainGroups,
        isLast: checkIsLast(res.data.domainGroups),
      });
    }
  } catch (error) {
    showError(error);
    yield put({ type: types.REQUEST_LOAD_MORE_ALL_DOMAIN_FAILED, error });
  }
}

function* createDomainGroup(data) {
  const { name, callbacks } = data;
  try {
    const res = yield DomainServices.createDomainGroup(name);
    if (res.data.code === 200) {
      yield put({ type: types.REQUEST_CREATE_DOMAIN_GROUP_SUCCESS });
      callbacks && callbacks.onSuccess(res);
      return;
    }

    if (res.data.code === 400) {
      yield put({
        type: types.REQUEST_CREATE_DOMAIN_GROUP_FAILED,
        error: res.data.message,
      });
      callbacks && callbacks.onFailed(res);
    }
  } catch (error) {
    callbacks && callbacks.onFailed(error);
    yield put({ type: types.REQUEST_CREATE_DOMAIN_GROUP_FAILED, error });
  }
}

function* deleteDomainGroup(data) {
  const { id, callbacks } = data;
  try {
    const res = yield DomainServices.deleteDomainGroup(id);
    if (res.data.code === 200) {
      yield put({ type: types.REQUEST_DELETE_DOMAIN_GROUP_SUCCESS });
      callbacks && callbacks.onSuccess(res);
      return;
    }

    if (res.data.code === 400) {
      // showError(res.data.message);
      yield put({
        type: types.REQUEST_DELETE_DOMAIN_GROUP_FAILED,
        error: res.data.message,
      });
      callbacks && callbacks.onFailed(res?.data?.message);
    }
  } catch (error) {
    // showError(error);
    callbacks && callbacks.onFailed(error);
    yield put({ type: types.REQUEST_DELETE_DOMAIN_GROUP_FAILED, error });
  }
}

function* migrateDomainGroup(data) {
  const {
    groupId,
    targetGroupId,
    amount,
    toggle,
    propsFormik,
    domains,
    deliveryThreshold,
    filters,
    callbacks,
  } = data;
  try {
    // Move domains in domain detail
    if (domains) {
      const resMigrateDomain = yield DomainServices.migrateDomainGroup({
        groupId,
        targetGroupId,
        domains,
      });
      if (isResponseSuccess(resMigrateDomain.data.code)) {
        yield loadDomainsInGroup({ idDomainGroup: groupId, filters });
        Notification('success', 'Migrate domains successfully!', 'Success', TIME_OUT_CLOSE_TOAST);
        toggle && toggle();
      } else {
        propsFormik && propsFormik.setSubmitting(false);
        showError(resMigrateDomain.data.message);
      }
      return;
    }

    if (deliveryThreshold) {
      const resMigrateDomain = yield DomainServices.migrateDomainGroup({
        groupId,
        targetGroupId,
        deliveryThreshold,
      });
      if (isResponseSuccess(resMigrateDomain.data.code)) {
        yield loadDomainsInGroup({ idDomainGroup: groupId, filters });
        Notification('success', 'Migrate domains successfully!', 'Success', TIME_OUT_CLOSE_TOAST);
        toggle && toggle();
      } else {
        propsFormik && propsFormik.setSubmitting(false);
        showError(resMigrateDomain.data.message);
      }
      return;
    }

    // Move by amount
    const resMigrateAmount = yield DomainServices.migrateDomainGroup({
      groupId,
      targetGroupId,
      amount,
    });
    if (isResponseSuccess(resMigrateAmount.data.code)) {
      yield put({
        type: types.REQUEST_MIGRATE_DOMAIN_GROUP_SUCCESS,
        data: resMigrateAmount.data.domainGroup,
      });
      callbacks && callbacks.onSuccess(resMigrateAmount);
    } else {
      callbacks && callbacks.onFailed(resMigrateAmount);
    }
  } catch (error) {
    callbacks && callbacks.onFailed(error);
    yield put({ type: types.REQUEST_MIGRATE_DOMAIN_GROUP_FAILED, error });
  }
}

function* loadDomainsInGroup(data) {
  const { idDomainGroup = '', filters = {}, startDateHour, endDateHour, callbacks } = data;
  const { sortDirections: sortDirection, sortFields: sortField } = filters;
  try {
    const res = yield DomainServices.loadDomainsInGroup({
      groupId: idDomainGroup,
      sortDirection,
      sortField,
      startDateHour,
      endDateHour,
    });

    const infoDomain = {
      domainsInGroup: res.data.domains,
      id: res.data.groupId,
      name: res.data.name,
      setting: res.data.setting,
      total: res.data.total,
    };

    if (isResponseSuccess(res.data.code)) {
      yield put({
        type: types.REQUEST_LOAD_DOMAINS_IN_GROUP_SUCCESS,
        infoDomain,
      });
      callbacks && callbacks.onSuccess();
    } else {
      yield put({
        type: types.REQUEST_LOAD_DOMAINS_IN_GROUP_FAILED,
        error: res.data.message,
      });
      callbacks && callbacks.onFailed();
      showError(res.data.message);
    }
  } catch (error) {
    showError(error);
    callbacks && callbacks.onFailed();
    yield put({ type: types.REQUEST_LOAD_DOMAINS_IN_GROUP_FAILED, error });
  }
}

function* resetDomainInGroup(data) {
  const { idDomainGroup, callbacks } = data;

  const formData = new FormData();
  formData.append('groupId', idDomainGroup);

  try {
    yield DomainServices.resetDomainInGroup({ groupId: idDomainGroup, body: formData });
    callbacks && callbacks.onSuccess();
  } catch (error) {
    showError(error);
    callbacks && callbacks.onFailed(error);
  }
}

function* saveDomainGroupSetting(data) {
  const {
    groupId,
    campaignCheck,
    deliveredThreshold,
    autoRenew = false,
    deliveredThresholdRenew = 0,
    domainRotation = false,
    domainUsageThreshold = 0,
    callbacks,
  } = data;
  try {
    const res = yield DomainServices.saveDomainGroupSetting({
      body: {
        groupId,
        campaignCheck,
        deliveredThreshold,
        autoRenew,
        deliveredThresholdRenew,
        domainRotation,
        domainUsageThreshold,
      },
    });
    callbacks && callbacks.onSuccess();

    const infoDomain = {
      name: res.data.name,
      setting: res.data.setting,
    };
    yield put({
      type: types.REQUEST_SAVE_DOMAIN_GROUP_SETTING_SUCCESS,
      infoDomain,
    });
    notifySuccess('Update successfully!');
  } catch (error) {
    callbacks && callbacks.onFailed();
    yield put({ type: types.REQUEST_SAVE_DOMAIN_GROUP_SETTING_FAILED, error });
    showError(error);
  }
}

//* Get campaign in domain
function* getCampaignInDomain(data) {
  const { callbacks, domainGroupId, limit, offset, loadMore = false } = data;
  try {
    const response = yield DomainServices.getCampaignDomain({
      domainGroupId,
      limit,
      offset,
    });

    let nextData = response?.data?.history || [];

    if (loadMore) {
      const dataCampaign = yield select((state) => state.domainReducer.campaign.data);
      nextData = [...dataCampaign, ...(response?.data?.history || [])];
    }

    yield put({
      type: types.REQUEST_GET_CAMPAIGN_IN_DOMAIN_SUCCESS,
      data: nextData,
      isLast: (response?.data?.history || []).length <= 0,
    });
  } catch (error) {
    callbacks && callbacks.onFailed();
    yield put({ type: types.REQUEST_GET_CAMPAIGN_IN_DOMAIN_FAILED, error });
    showError(error);
  }
}

function* getResponderInDomain(data) {
  const { callbacks, domainGroupId, page, size, loadMore = false } = data;
  try {
    const response = yield DomainServices.getResponderDomain({
      domainGroupId,
      page,
      size,
    });

    let nextData = response?.data || [];

    if (loadMore) {
      const prevData = yield select((state) => state.domainReducer.responder.data);
      nextData = [...prevData, ...(response?.data || [])];
    }

    yield put({
      type: types.REQUEST_GET_RESPONDER_IN_DOMAIN_SUCCESS,
      data: nextData,
      isLast: (response?.data || []).length <= 0,
    });
  } catch (error) {
    callbacks && callbacks.onFailed();
    yield put({ type: types.REQUEST_GET_RESPONDER_IN_DOMAIN_FAILED, error });
    showError(error);
  }
}

function* releaseDomainNow(data) {
  const { callbacks, body = {} } = data;
  try {
    const res = yield DomainServices.releaseNow(body);
    if (isResponseSuccess(res?.data?.code)) {
      callbacks && callbacks.onSuccess();
      notifySuccess('Release successfully!');
    }
  } catch (error) {
    callbacks && callbacks.onFailed();
    yield put({ type: types.REQUEST_RELEASE_DID_NOW_FAILED, error });
    showError(error);
  }
}

function* releaseDomainSelected(data) {
  const { callbacks, body = {} } = data;
  try {
    const res = yield DomainServices.releaseDomain(body);
    if (isResponseSuccess(res?.data?.code)) {
      notifySuccess('Release request sent! The domain(s) will be released in few minutes!');
      yield delay(2000);
      callbacks && callbacks.onSuccess();
    } else {
      yield put({ type: types.REQUEST_RELEASE_DOMAIN_SELECTED_FAILED });
      showError(res?.data?.error || 'Something went wrong');
      callbacks && callbacks.onFailed();
    }
  } catch (error) {
    callbacks && callbacks.onFailed();
    yield put({ type: types.REQUEST_RELEASE_DOMAIN_SELECTED_FAILED, error });
    showError(error);
  }
}

function* getBuyingProcess({ groupId = '', callbacks }) {
  try {
    const response = yield DomainServices.getBuyingProcess(groupId);
    const isError = response?.data?.error;
    if (isError) {
      showError(isError.toString() || '');
      callbacks && callbacks.onFailed(isError.toString());
    } else {
      callbacks && callbacks.onSuccess(response);
    }

    //* if process is available -> recall API
    if (isArray(response?.data?.process) && !isEmpty(response?.data?.process)) {
      yield delay(3000);
      yield getBuyingProcess({ groupId, callbacks });
    }
  } catch (error) {
    showError(error.toString() || '');
    callbacks && callbacks.onFailed(error.toString());
  }
}

export default function* () {
  yield takeLatest(types.REQUEST_GET_CAMPAIGN_IN_DOMAIN, getCampaignInDomain);
  yield takeLatest(types.REQUEST_GET_RESPONDER_IN_DOMAIN, getResponderInDomain);
  yield takeLatest(types.REQUEST_GET_DOMAIN, getDomain);
  yield takeLatest(types.REQUEST_ADD_DOMAIN, addDomain);
  yield takeLatest(types.REQUEST_DELETE_DOMAIN, deleteDomain);
  yield takeLatest(types.REQUEST_SEARCH_DOMAIN, searchDomain);
  yield takeLatest(types.REQUEST_BUY_DOMAIN, buyDomain);
  yield takeLatest(types.REQUEST_UPDATE_ALL_DOMAIN, updateAllDomain);
  yield takeLatest(types.REQUEST_UPDATE_DOMAIN, updateDomain);
  yield takeLatest(types.REQUEST_SETUP_DOMAIN, setupDomain);

  yield takeLatest(types.REQUEST_GET_ALL_DOMAIN_GROUP, getAllDomainGroup);
  yield takeLatest(types.REQUEST_CREATE_DOMAIN_GROUP, createDomainGroup);
  yield takeLatest(types.REQUEST_DELETE_DOMAIN_GROUP, deleteDomainGroup);
  yield takeLatest(types.REQUEST_MIGRATE_DOMAIN_GROUP, migrateDomainGroup);
  yield takeLatest(types.REQUEST_LOAD_DOMAINS_IN_GROUP, loadDomainsInGroup);
  yield takeLatest(types.REQUEST_RESET_DOMAIN_IN_GROUP, resetDomainInGroup);
  yield takeLatest(types.REQUEST_LOAD_MORE_ALL_DOMAIN, loadMoreAllDomain);

  yield takeLatest(types.REQUEST_SAVE_DOMAIN_GROUP_SETTING, saveDomainGroupSetting);
  yield takeLatest(
    types.REQUEST_GET_BUYING_PROCESS,
    handleWorker({
      handler: getBuyingProcess,
      cancelled: take([typeUnmounted(components.domainDetail)]),
    })
  );

  // Listen To Re-get data
  yield takeLatest(types.REQUEST_DELETE_DOMAIN_SUCCESS, getDomain);
  yield takeLatest(types.REQUEST_ADD_DOMAIN_SUCCESS, getDomain);
  yield takeLatest(types.REQUEST_UPDATE_DOMAIN_SUCCESS, getDomain);
  yield takeLatest(types.REQUEST_UPDATE_ALL_DOMAIN_SUCCESS, getDomain);
  yield takeLatest(types.REQUEST_SETUP_DOMAIN_SUCCESS, getDomain);
  yield takeLatest(types.REQUEST_BUY_DOMAIN_SUCCESS, getDomain);
  yield takeLatest(types.REQUEST_RELEASE_DOMAIN_NOW, releaseDomainNow);
  yield takeLatest(types.REQUEST_RELEASE_DOMAIN_SELECTED, releaseDomainSelected);
}
